class ProductCard extends HTMLElement {

    constructor() {
        super()
        this.init()
    }

    /**
     * The `init` function initializes the component by setting up event listeners.
     */
    private init(): void {
        this.setupEventListeners()
    }

    /**
     * The function sets up event listeners for changing color, opening quick add, and closing quick
     * add.
     */
    private setupEventListeners(): void {
        this.initChangeColorEvent()
        this.initOpenQuickAddEvent()
        this.initCloseQuickAddEvent()
    }

    /**
     * The function removes the 'selected' class from all color variants
     * except for the specified `colorVariant`.
     * @param {any} colorVariant
     */
    private deselectedColorVariants(colorVariant: any): void {
        const colorVariants = this.querySelectorAll('.product-card__color-variant')

        colorVariants.forEach((item) => {
            if (item !== colorVariant) {
                item.classList.remove('selected')
            } else {
                item.classList.add('selected')
            }
        })
    }

    /**
     * The function sets a data attribute to show or hide a specific list
     * element based on a condition.
     * @param {any} listToShow
     */
    private showColorVariantSizes(listToShow: any): void{
        const colorVariantSizes = this.querySelectorAll('.product-card__quick-add-list')

        colorVariantSizes.forEach((colorVariantSize) => {
            if ( colorVariantSize === listToShow ) {
                colorVariantSize.setAttribute('data-show', 'true')
            } else {
                colorVariantSize.setAttribute('data-show', 'false')
            }
        })
    }

    /**
     * The function updates product thumbnails based on the selected color.
     * @param {string | null} color
     */
    private changeProductThumbnails(color: string | null): void {
        const imagesContainer = this.querySelector('.product-card__images')
        let images = imagesContainer?.querySelectorAll('img')
        const productMedia = this.querySelector('[data-product-media]')?.textContent
        const productMediaJSON = productMedia ? JSON.parse(productMedia) : ''
        const productMediaSelect = productMediaJSON.filter((media: { alt: string | null }) => media.alt === color)
        
        if(productMediaSelect.length < 2) { // If only there is a image
            imagesContainer?.classList.remove('swipe-image')
            var lastImage = images ? images[1] : null;
            lastImage?.parentNode?.removeChild(lastImage);
        } else if (productMediaSelect.length > 2 && images?.length == 1) { // If there is two images and one on imagesList
            imagesContainer?.classList.add('swipe-image')
            const newImage: HTMLImageElement = document.createElement('img')
            imagesContainer?.appendChild(newImage)
            images = imagesContainer?.querySelectorAll('img')
        }

        images?.forEach((image, index) => {
            image.src = productMediaSelect[index].src
        })
    }

    /**
     * The function initializes a click event listener on color variants in a
     * product card, updating the product details and thumbnails based on the selected color.
     */
    private initChangeColorEvent(): void {
        const colorVariants = this.querySelectorAll('.product-card__color-variant')
        
        colorVariants.forEach((colorVariant) => {
            colorVariant.addEventListener('click', () => {
                const color = colorVariant.getAttribute('data-color')
                const variantUrl = colorVariant.getAttribute('data-url') || ''
                const list = this.querySelector(`.product-card__quick-add-list[data-color="${color}"]`)

                this.querySelector('.product-card__images')?.setAttribute('href', variantUrl)
                this.querySelector('.product-card__title a')?.setAttribute('href', variantUrl)
                this.deselectedColorVariants(colorVariant)
                this.showColorVariantSizes(list)
                this.changeProductThumbnails(color)
            })
        })
    }

    /**
     * The function initializes an event listener for a button click to toggle
     * the visibility of elements.
     */
    private initOpenQuickAddEvent(): void {
        const button = this.querySelector<HTMLButtonElement>('#quick-add-button')
        const quickAdd = this.querySelector('#quick-add')

        button?.addEventListener('click', () => {
            // button.dispatchEvent(new Event('click'));
            button.classList.toggle('active')
            quickAdd?.classList.toggle('active')
            this.classList.add('active')
        })
    }

    /**
     * The function removes the 'active' class from specific elements when the
     * mouse leaves the target element.
     */
    private initCloseQuickAddEvent(): void {
        this.addEventListener('mouseleave', () => {
            const button = this.querySelector('#quick-add-button')
            const quickAdd = this.querySelector('#quick-add')

            this.classList.remove('active')
            button?.classList.remove('active')
            quickAdd?.classList.remove('active')
        })  
    }
}

export default ProductCard